export default __webpack_public_path__ + "static/media/4-auth-bg.92d6f930.jpg";